import { createTheme } from "@mui/material/styles";

export const configureDesignSystem = createTheme({
  palette: {
    primary: {
      main: "#0C20B5",
    },
    secondary: {
      main: "#B0B0B0",
    },
    error: { main: "#B02F2F" },
  },
  typography: {
    fontFamily: "Outfit",
    allVariants: {
      textTransform: "none",
      letterSpacing: ".2px",
      lineHeight: "20px",
      color: "#343E75",
    },
  },
  shape: { borderRadius: 8 },
  spacing: 8,
  components: {
    MuiTypography: {
      defaultProps: {
        sx: {
          textTransform: "none",
          letterSpacing: ".2px",
          lineHeight: "20px",
          color: "#343E75",
          fontFamily: "Outfit",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
        sx: { fontFamily: "'Outfit', sans-serif" },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        size: "small",
        sx: { borderRadius: "2000px", padding: "4px 16px" },
      },
      styleOverrides: {
        colorInherit: {
          backgroundColor: "#F2F3F5",
          borderColor: "#E4E7EB",
          color: "#343E75",
          border: "1px solid #CFCFCF",
        },
      },
    },
  },
});
